import { lockScroll } from '../modules/lockScroll.js';

var nav = {},
		DOM = {},
		prop = {
			active: false,
			busy: false,
			firstTime: true
		};


function open() {
	if (prop.busy == false) {
		prop.busy = true;
		prop.active = true;
		DOM.$this.addClass('is-active');
		DOM.$sitewide.addClass('animate-menu');
		let offset = $(window).scrollTop(),
				mobFix = (offset <= 64 && Modernizr.mq('(max-width: 767px)')) ? true : false;
		if (mobFix) {
			DOM.$sitewide.css({'position' : 'absolute'});
			DOM.$sideMenu.css({'transform' : 'translateY(-'+(64-offset)+'px)'});
		}
		if (prop.firstTime == true) {
			prop.firstTime = false;
			$('body').icons.init('.svg-icon', prop.$this);
		}
		setTimeout(function() {
			DOM.$sitewide.addClass('has-open-menu');
			DOM.$btn.addClass('is-active');
			DOM.$this.addClass('animate');
			DOM.$this.addClass('animate-elements');
		}, 100);
		setTimeout(function() {
			if (mobFix) {
				DOM.$sitewide.removeClass('animate-menu');
				DOM.$sitewide.removeAttr('style');
				DOM.$sideMenu.removeAttr('style');
			}
			lockScroll.init(true);
			prop.busy = false;
			trapFocus(DOM.$this[0]);
		}, 850);
	}
}

function close() {
	if (prop.busy == false) {
		prop.busy = true;
		prop.active = false;
		lockScroll.init(false);
		let offset = $(window).scrollTop(),
				mobFix = (offset <= 64 && Modernizr.mq('(max-width: 767px)')) ? true : false;
		if (mobFix) {
			DOM.$sitewide.css({'position' : 'absolute'});
			DOM.$sideMenu.css({'transform' : 'translateY(-'+(64-offset)+'px)'});
		}
		setTimeout(function() {
			if (mobFix) {
				DOM.$sideMenu.css({'transform' : 'translateY(0px)'});
			}
			DOM.$sitewide.addClass('animate-menu');
			DOM.$sitewide.removeClass('has-open-menu');
			DOM.$btn.removeClass('is-active');
			DOM.$this.removeClass('animate');
			setTimeout(function() {
				if (mobFix) {
					DOM.$sitewide.removeAttr('style');
					DOM.$sideMenu.removeAttr('style');
				}
				DOM.$sitewide.removeClass('animate-menu');
				DOM.$this.removeClass('is-active');
				DOM.$this.removeClass('animate-elements');
				prop.busy = false;
			}, 600);
		}, 100);
	}
}

function trapFocus(modalElement) {
	const focusableElements = modalElement.querySelectorAll(
	  'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
	);

	const first = focusableElements[0];
	const last = focusableElements[focusableElements.length - 1];

	modalElement.addEventListener('keydown', function (e) {
	  if (e.key === 'Tab') {
			first.classList.remove('force-focus');

			if (e.shiftKey) {
				if (document.activeElement === first) {
					e.preventDefault();
					last.focus();
				}
			} else {
				if (document.activeElement === last) {
					e.preventDefault();
					first.focus();
				}
			}
		} else if (e.key === 'Escape') {
			close();
		}
	});

	first.classList.add('force-focus');
	first.focus();
 }

nav.init = function() {
	DOM = {
		$this: $('#navigation'),
		$btn: $('.js-toggle-menu'),
		$sitewide: $('#sitewide, #sitewide-beam'),
		$sideMenu: $('#sitewide #top-side-menu')
	}
	DOM.$btn.click(function(e) {
		e.preventDefault();
		if (prop.active == false) {
			if (!$(this).hasClass('is-active-for-search')) {
				open();
			}
		} else {
			close();
		}
	});
	$('#primary-menu ul li.is-parent').hover(function() {
		$('#primary-menu ul li.is-current-parent').addClass('is-inactive');
	}, function() {
		$('#primary-menu ul li.is-current-parent').removeClass('is-inactive');
	});
}

nav.resize = function() {
	// resize
}

export { nav };
